import { useTranslation } from "react-i18next";
import { certifications } from "../data/certifications";

export default function Certifications() {
  const { t, i18n } = useTranslation('translation', { useSuspense: false });
  
  return (
    <section className="section">
      <h2>{t('title.certifications')}</h2>
      <ul className="certification-list">
        {certifications[i18n.language].map(cert => (
          <li key={cert.title}>{cert.title} - {cert.institution} - {cert.duration}
          </li>
        ))}
      </ul>
    </section>
  );
}
